import React from 'react';
import PropTypes from 'prop-types';

import FilterButton from 'components/ui/filter_button';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';

export function CheckboxFilter({
  addFilter,
  buttonIcon,
  className,
  filterTag,
  label,
  name,
  options,
  removeFilter,
  selected,
  hideSelectedCount,
}) {
  const handleCheckboxFilterChange = (event) => {
    const handler = event.target.checked ? addFilter : removeFilter;
    handler(name, event.target.value);
  };

  const selectionTagProps = {};

  if (hideSelectedCount) {
    selectionTagProps.filtersApplied = selected.length > 0;
  } else if (filterTag) {
    selectionTagProps.filterTag = filterTag;
  } else {
    selectionTagProps.selectedLength = selected.length;
  }

  return (
    <FilterButton
      {...selectionTagProps}
      buttonIcon={buttonIcon}
      className={className}
      label={label}
      name={name}
    >
      <FilterCheckboxGroup
        options={options}
        selected={selected}
        onChange={handleCheckboxFilterChange}
      />
    </FilterButton>
  );
}

CheckboxFilter.propTypes = {
  addFilter: PropTypes.func,
  buttonIcon: PropTypes.object,
  className: PropTypes.string,
  filterTag: PropTypes.string,
  hideSelectedCount: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  removeFilter: PropTypes.func,
  selected: PropTypes.array,
};

export default CheckboxFilter;
